import type { LocationDetail } from "@/entities/location";

import { useTranslation } from "react-i18next";

import { getLocationAncestors } from "@/entities/ancestor";

export const useLocationSectorsTabTitle = (location?: LocationDetail) => {
  const { t } = useTranslation();

  const locationsAncestors = getLocationAncestors(location?.ancestors);

  return locationsAncestors.length > 1
    ? t("global:subSectorPlural")
    : t("global:sectorPlural");
};
